import React from 'react'
import classnames from 'classnames'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  table: {
    width: '100%',
  },
  title: {
    flexGrow: 1,
    textAlign: 'left',
    paddingRight: theme.spacing(4),
    borderRight: '1px solid #e5e5e5',
  },
  bold: {
    fontWeight: 'bold',
  },
  value: {
    flexGrow: 1,
    textAlign: 'right',
  },
  highlightRow: {
    backgroundColor: '#f0f0f0',
  },
  tr: {
    
  },
  td: ({padding}) => ({
    padding: `${padding}px`,
  }),
}))

const FieldSummary = ({
  data,
  alternate = true,
  padding = 2,
}) => {
  const classes = useStyles({padding})
  return (
    <table cellSpacing="0" cellPadding="0" border="0" className={ classes.table }>
      <tbody>
        {
          data.map((row, i) => {
            const isHighlighted = alternate ?
              i % 2 == 0 :
              false

            return (
              <tr key={ i } className={ classnames(classes.tr, {[classes.highlightRow]: isHighlighted})}>
                <td width="50%" valign="top" className={ classnames(classes.td, classes.title, {[classes.bold]: row.plainTitle ? false : true}) }>
                  { row.title }:
                </td>
                <td valign="top" className={ classnames(classes.td, classes.value, {[classes.bold]: row.boldValue}) }>
                  { row.value }
                </td>
              </tr>
            )
          })
        }
      </tbody>
    </table>
  )
}

export default FieldSummary